import { AxiosResponse } from "axios";
import { OrganizationKeyName } from "../../../model/Organization";
import { axiosAuthenticated, updateSorting } from "../../../service/http";
import {
  KitchenCategoriesSuccessResponse,
  KitchenCategorySuccessResponse,
  MutateKitchenCategoryPayload,
} from "../models/kitchen-category";
import { UpdateSortingMutationPayload } from "../../../model/UpdateSortingData";
import { PostPayload, UpdateData } from "../../../model/http-crud-models";

export const kitchenCategoriesHttp = {
  getKitchenCategories: async (organizationKeyName?: OrganizationKeyName) => {
    const url = `/organizations/${organizationKeyName}/shop-kitchen-categories`;
    const response = await axiosAuthenticated.get<
      any,
      AxiosResponse<KitchenCategoriesSuccessResponse>
    >(url);
    const kitchenCategories = response.data.data;
    return kitchenCategories;
  },

  getKitchenCategory: async (
    organizationKeyName?: OrganizationKeyName,
    id?: string
  ) => {
    const url = `/organizations/${organizationKeyName}/shop-kitchen-categories/${id}`;
    const response = await axiosAuthenticated.get<
      any,
      AxiosResponse<KitchenCategorySuccessResponse>
    >(url);
    const kitchenCategory = response.data.data;
    return kitchenCategory;
  },

  createKitchenCategory: async ({
    organizationKeyName,
    data,
  }: PostPayload<MutateKitchenCategoryPayload>): Promise<string> => {
    const url = `/organizations/${organizationKeyName}/shop-kitchen-categories`;
    const response = await axiosAuthenticated.post<
      any,
      AxiosResponse<{ id: string }>
    >(url, data);

    return response.data.id;
  },

  updateKitchenCategory: async ({
    organizationKeyName,
    id,
    data,
  }: UpdateData<MutateKitchenCategoryPayload>): Promise<string> => {
    const url = `/organizations/${organizationKeyName}/shop-kitchen-categories/${id}`;
    const response = await axiosAuthenticated.put<any, AxiosResponse>(
      url,
      data
    );

    return response.data.id;
  },

  updateKitchenCategoriesSorting: async ({
    organizationKeyName,
    data,
  }: UpdateSortingMutationPayload): Promise<string> => {
    return updateSorting({
      organizationKeyName,
      apiRoute: "shop-kitchen-categories",
      data,
    });
  },
};
